import React, { useState } from 'react'
import { InputField } from '../../../components/InputField'
import { GO_DE_GQL_BACKEND_URL } from '../../../constants'
import { MiniDeLoading } from '../../../components/DeLoading'
import OfferCard from '../../../components/OfferCard'
import { FetchApi } from '../../../api/fetch'

function DeleteListing() {
   const [isLoading, setIsLoading] = useState(false)
   const [searchText, setSearchText] = useState('')
   const [offer, setOffer] = useState()

   const handleSearch = async (e: any) => {
      setSearchText(e.target.value)
      if (e.target.value?.length > 5) {
         setIsLoading(true)
         try {
            const res: any = await FetchApi( {
               endpoint:`${GO_DE_GQL_BACKEND_URL}`,
               method: "POST",
               body:  ({
                  query: `
                query MyQuery($mint: String) {
                  offers(mint: $mint) {
                    nodes {
                     collection
                     name
                     marketplace
                     mint
                     metadata
                    }
                  }
                
              }`,
                  variables: { mint: e.target.value }
               })
            })
            setOffer(res?.data?.offers?.nodes[0])
            setIsLoading(false)
         } catch (error) {
            console.log(error);
            setIsLoading(false)
         }
      } else {
         return
      }
   }
   const resetSearch = () => {
      setOffer(undefined)
      setSearchText('')
   }

   return (
      <div className="flex flex-col w-11/12 mx-auto mt-8 lg:mt-10 mx-6">
         <div className="mt-0 flex flex-row mb-4 justify-between items-center sm:flex-row">
            <h1 className="font-semibold text-3xl text-left">
               Delete Stale Listing Tool
            </h1>
         </div>
         <div>
            <InputField
               type="text"
               value={searchText}
               onChange={handleSearch}
               className="w-full mt-2 mb-1 mx-0 bg-gray-90 border-gray-80 rounded-full"
               placeholder="Search for NFT Lisitng (NFT Token Address) "
            />
         </div>
         <div>
            {
               isLoading &&
               <div>
                  <MiniDeLoading />
               </div>
            }
            {
               (!isLoading && !offer && searchText) &&
               <div className='text-center'>
                  <h1>No offer found</h1>
               </div>
            }
            {
               (!isLoading && offer) &&
               <OfferCard data={offer} resetSearch={resetSearch} />
            }
         </div>
      </div>
   )
}

export default DeleteListing